import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postUnlinkOrganization } from '@api';
import { removeOrganization } from '../all/actions';

export const coreOrganizationsUnlinkPostAsyncSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [ removeOrganization ]
	},
	name: 'CoreOrganizationsUnlink',
	receive: false,
	request: true,
	requestHandler: postUnlinkOrganization
});
